angular.module('NiacsProjectApp.controllers-step5', [
])
.controller('AddEditMonitorCtrl',['$scope','$uibModalInstance','monitor',
    function($scope,$uibModalInstance,monitor){
    $scope.monitor = monitor;
    $scope.dismiss = $uibModalInstance.dismiss;
    $scope.save = function() {
        $uibModalInstance.close($scope.monitor);
    };
}])
.controller('MonitorCtrl',['$scope','$routeParams','$filter','$uibModal','ProjectService','ShowHideService','DialogService',
    function($scope,$routeParams,$filter,$uibModal,ProjectService,ShowHideService,DialogService){
        function editMonitor(monitor) {
            niacs.debug("editMonitor",monitor);
            $uibModal.open({
              templateUrl: 'partials/dialogs/add-edit-monitor.html',
              controller: 'AddEditMonitorCtrl',
              windowClass: 'niacs-monitor-dialog',
              size: 'lg',
              keyboard: false,
              backdrop: 'static',
              resolve:{
                monitor: function() { return angular.extend({},monitor); }
              }
            }).result.then(function(m){
                angular.extend(monitor,m);
                ProjectService.save();
            },function(){});
        }
        function deleteMonitor(monitor) {
            niacs.debug("deleteMonitor",monitor);
            var refCount = 0;
            angular.forEach(niacs.collectObjectives($scope.project,true),function(objective) {
                if(objective.monitor && niacs.findById(objective.monitor,monitor.id)) {
                    refCount++;
                }
            });
            function doRemove() {
                // find all monitor refs and remove them.
                angular.forEach(niacs.collectObjectives($scope.project,true),function(objective) {
                    if(objective.monitor && niacs.removeById(objective.monitor,monitor.id)) {
                        niacs.debug('dropped monitorRef from objective',objective);
                    }
                });
                // remove the monitor from the project.
                if(niacs.removeById($scope.project.monitor,monitor.id)) {
                    niacs.debug("dropped monitor from project",monitor);
                    ProjectService.save();
                }
            }
            var dialogContents = {
                message: 'Are you sure you want to remove this monitoring variable?',
                warning: 'This cannot be undone.',
                okText: 'Yes, remove this monitoring variable',
                cancelText: 'No, keep this monitoring variable',
                conditions: []
            };
            if(refCount > 0) {
                dialogContents.conditions.push(refCount+' objectives have been marked as applicable for this monitoring variable.');
            }
            DialogService.safe(dialogContents).then(function() {
                niacs.info('user confirmed deletion of monitoring variable.');
                doRemove();
            });
        }
        function getMonitorControls(monitor) {
            return [{
                icon: 'pencil',
                action: function() { editMonitor(monitor); },
                tooltip: 'Edit Monitoring Variable'
            },{
                icon: 'times-circle',
                action: function() { deleteMonitor(monitor); },
                tooltip: 'Delete Monitoring Variable'
            }];
        }
        $scope.addMonitoringPlan = function() {
            $uibModal.open({
              templateUrl: 'partials/dialogs/add-edit-monitor.html',
              controller: 'AddEditMonitorCtrl',
              windowClass: 'niacs-monitor-dialog',
              size: 'lg',
              keyboard: false,
              backdrop: 'static',
              resolve:{
                monitor: function() { return {}; }
              }
            }).result.then(function(m){
                m.id = niacs.guid();
                if(!$scope.project.monitor) {
                    $scope.project.monitor = [];
                }
                $scope.project.monitor.push(m);
                ProjectService.save();
               var uniqueId = "monitor."+m.id;
               ShowHideService.get(uniqueId,true).show = true;
               ShowHideService.accordionChange(uniqueId);
            },function(){});
        };
        $scope.monitorRefVisibility = {};
        $scope.initMonitorRefVisibility = function(monitor) {
            if(typeof($scope.monitorRefVisibility[monitor.id]) == 'undefined') {
                $scope.monitorRefVisibility[monitor.id] = monitor.$refCount ? true : false;
            }
        };
        $scope.getMonitorRef = function(objective,monitor) {
            if(objective.monitor) {
                for(var i = 0; i < objective.monitor.length; i++) {
                    if(objective.monitor[i].id == monitor.id) {
                        return objective.monitor[i];
                    }
                }
            }
            return {id: monitor.id, applicable: false}; // new empty reference.
        };
        $scope.changeApplicability = function(objective,monitorRef) {
            niacs.debug("changeApplicability",objective,monitorRef);
            // for simplicity always just remove and re-add the tactic reference.
            if(objective.monitor) {
                niacs.removeById(objective.monitor,monitorRef.id);
            }
            if(monitorRef.applicable) {
                if(!objective.monitor) {
                    objective.monitor = [];
                }
                objective.monitor.push(monitorRef);
            }
            ProjectService.save();
        };
        function getContexts() {
            var project = $scope.project,contexts,i,j,objectives,tmp;
            if(project && project.$vuln_region && project.$vuln_region.$units) {
                //unit in project.units | inflate:project.$vuln_region.$units
                contexts = [].concat($filter('inflate')(project.units,project.$vuln_region.$units));
                if($scope.contexts) {
                    for(i = 0; i < contexts.length; i++) {
                        $scope.contexts[i] = contexts[i];
                    }
                } else {
                    $scope.contexts = contexts;
                }
                $scope.goals = niacs.collectGoals(project,true);
                objectives = niacs.collectObjectives(project,true);
                $scope.objectives = objectives;
                $scope.objectiveCount = objectives.length;
                if(project.monitor && project.monitor.length) {
                    for(i = 0; i < project.monitor.length; i++) {
                        project.monitor[i].$refCount = 0;
                        project.monitor[i].$controls = getMonitorControls(project.monitor[i]);
                    }
                    for(i = 0; i < objectives.length; i++) {
                        if(objectives[i].monitor) {
                            for(j = 0; j < objectives[i].monitor.length; j++) {
                                if ((tmp = niacs.findById(project.monitor,objectives[i].monitor[j].id)) != null) {
                                    tmp.$refCount++;
                                }
                            }
                        }
                    }
                }
            }
        }
        $scope.$watch('project.$vuln_region.$units',getContexts);
        $scope.$watch('project.$updateCount',getContexts);
        ProjectService.get($routeParams,'MonitorCtrl',function(project){
            $scope.project = project;
        });
}]);
